import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-571a0c16"), n = n(), _popScopeId(), n);

const _hoisted_1 = ["src"];
const _hoisted_2 = ["href"];

const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "subtitle"
}, "Source", -1));

const _hoisted_4 = {
  class: "title_block"
};
const _hoisted_5 = {
  class: "megatitle"
};
const _hoisted_6 = {
  class: "al-it-cen subtitle_block"
};
const _hoisted_7 = {
  class: "flx-dir-col al-it-start"
};
const _hoisted_8 = ["src"];
const _hoisted_9 = {
  class: "subtitle"
};
const _hoisted_10 = {
  class: "subtitle subtitle_date"
};
const _hoisted_11 = {
  class: "body_block"
};
const _hoisted_12 = {
  key: 2,
  class: "inaccurate-event-info italic primary-color m-text m-subtitle",
  style: {
    "min-width": "fit-content"
  }
};
const _hoisted_13 = {
  key: 3,
  class: "inaccurate-event-info italic primary-color m-text m-subtitle",
  style: {
    "min-width": "fit-content"
  }
};
const _hoisted_14 = {
  key: 4,
  class: "body_block"
};
import { computed, ref, watch } from 'vue';
import { format } from 'date-fns';
import omit from 'lodash/omit';
import { Link as LinkIcon } from '@element-plus/icons-vue';
import BusIcon from '@/assets/BusSolid.svg';
import BookIcon from '@/assets/BookSolid.svg';
import PaletteIcon from '@/assets/JustPalette.svg';
import ChampagneGlassesIcon from '@/assets/ChampagneGlasses.svg';
import WandMagicIcon from '@/assets/WandMagic.svg';
import StoreIcon from '@/assets/store-solid.svg';
import PeopleGroupIcon from '@/assets/people-group-solid.svg';
import MasterClassIcon from '@/assets/person-chalkboard.svg';
import useMainStore from '@/store';
import PriceBlock from '@/ui/PriceBlock.vue';
export default {
  __name: 'CardComp',
  props: {
    id: {
      required: true,
      type: String
    },
    name: {
      required: true,
      type: String
    },
    categories: {
      required: true,
      type: Object
    },
    source: {
      required: true,
      type: String
    },
    price: {
      required: true,
      type: String
    },
    eventDate: {
      required: true,
      type: String
    },
    isAddressAccurate: {
      required: true,
      type: Boolean
    },
    withoutExactTime: {
      required: true,
      type: Boolean
    },
    image: Object,
    place: Object,
    coordinates: Object,
    description: String,
    isBriefVersion: Boolean,
    cardShadow: String
  },

  setup(__props) {
    const props = __props;
    const store = useMainStore();
    const descriptionRef = ref(null);
    const isDescriptionTruncated = ref(false);
    watch(descriptionRef, () => {
      if (descriptionRef.value) {
        const element = descriptionRef.value;

        if (element.offsetHeight < element.scrollHeight) {
          isDescriptionTruncated.value = true;
        }
      }
    });

    const onCardClick = () => {
      if (isDescriptionTruncated.value) {
        store.setEventInfoPopupVisibility(true);
        store.setChosenEvent(omit(props, ['isBriefVersion', 'cardShadow']));
      }
    };

    const filterToIconSrcMap = {
      lectures: BookIcon,
      shows: WandMagicIcon,
      parties: ChampagneGlassesIcon,
      trips: BusIcon,
      exhibitions: PaletteIcon,
      market: StoreIcon,
      meets: PeopleGroupIcon,
      masterClass: MasterClassIcon
    };
    const formattedDate = computed(() => format(new Date(props.eventDate), 'do MMMM'));
    const formattedTime = computed(() => format(new Date(props.eventDate), "HH':'mm"));
    return (_ctx, _cache) => {
      const _component_el_icon = _resolveComponent("el-icon");

      const _component_el_card = _resolveComponent("el-card");

      return _openBlock(), _createBlock(_component_el_card, {
        onClick: onCardClick,
        shadow: __props.cardShadow ?? 'always',
        "body-style": __props.isBriefVersion ? {
          cursor: 'pointer'
        } : {
          padding: 0
        },
        class: _normalizeClass(!__props.isBriefVersion ? 'card' : '')
      }, {
        default: _withCtx(() => [__props.image ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          class: "event_image",
          src: __props.image.downloadUrl,
          alt: "Event image"
        }, null, 8, _hoisted_1)) : _createCommentVNode("", true), !__props.isBriefVersion ? (_openBlock(), _createElementBlock("a", {
          key: 1,
          class: "al-it-cen jus-con-end source_label",
          href: __props.source,
          target: "_blank"
        }, [_hoisted_3, _createVNode(_component_el_icon, {
          class: "info-color el-icon--right"
        }, {
          default: _withCtx(() => [_createVNode(_unref(LinkIcon))]),
          _: 1
        })], 8, _hoisted_2)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_4, [_createElementVNode("span", _hoisted_5, _toDisplayString(__props.name), 1)]), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.categories.items, category => {
          return _openBlock(), _createElementBlock("div", {
            class: "flx",
            key: category.id
          }, [_createVNode(_component_el_icon, {
            class: "el-icon--left"
          }, {
            default: _withCtx(() => [_createElementVNode("img", {
              src: filterToIconSrcMap[category.value],
              class: "category_icon"
            }, null, 8, _hoisted_8)]),
            _: 2
          }, 1024), _createElementVNode("span", _hoisted_9, _toDisplayString(category.label), 1)]);
        }), 128))]), _createElementVNode("span", _hoisted_10, _toDisplayString(_unref(formattedTime)) + ", " + _toDisplayString(_unref(formattedDate)), 1)]), _createElementVNode("div", _hoisted_11, [_createVNode(PriceBlock, {
          price: __props.price
        }, null, 8, ["price"])]), !__props.isAddressAccurate ? (_openBlock(), _createElementBlock("span", _hoisted_12, " Inaccurate address. ")) : _createCommentVNode("", true), __props.withoutExactTime ? (_openBlock(), _createElementBlock("span", _hoisted_13, " Inaccurate time. ")) : _createCommentVNode("", true), __props.description || !__props.isBriefVersion ? (_openBlock(), _createElementBlock("div", _hoisted_14, [_createElementVNode("span", {
          class: _normalizeClass(__props.isBriefVersion ? 'truncate-4-lines description' : 'description'),
          ref_key: "descriptionRef",
          ref: descriptionRef
        }, _toDisplayString(__props.description), 3), _createTextVNode(" " + _toDisplayString(!__props.description && !__props.isBriefVersion ? 'No description.' : ''), 1)])) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["shadow", "body-style", "class"]);
    };
  }

};